import { computed } from 'vue'
import type { ComputedRef, Ref } from 'vue'
// types
import type { StrapiCtaSettings, StrapiSingleResponse, StrapiStatsItem } from '@ts-strapi/interfaces'
// constants
import { GLOBAL_STATS_STATE_KEY } from '@composables/tools/global-stats.hook'
// hooks
import { useStrapiFetch } from '@api/strapi/use-strapi-fetch.hook'

interface StrapiCtaSettingsHookReturn {
  refCtaSettings: ComputedRef<StrapiCtaSettings | null>
  refPending: Ref<boolean>
  refError: Ref<Error | null>
  refresh: () => Promise<void>
}

export const useStrapiCtaSettings = async (): Promise<StrapiCtaSettingsHookReturn> => {
  const strapiFetch = useStrapiFetch()
  const refGlobalStats = useState<StrapiStatsItem[]>(GLOBAL_STATS_STATE_KEY, () => [])

  const { data, pending, error, refresh } = await useAsyncData(
    'strapi:cta-settings',
    () => strapiFetch<StrapiSingleResponse<StrapiCtaSettings>>('/cta-setting', {
      params: {
        'populate[stickyBottomBar][populate][content][populate]': '*',
        'populate[stats][populate]': '*',
      },
    }),
  )

  refGlobalStats.value = data.value?.data?.stats?.items ?? []

  return {
    refCtaSettings: computed(() => data.value?.data ?? null),
    refPending: pending,
    refError: error as Ref<Error | null>,
    refresh: () => refresh(),
  }
}
